import { BehaviorSubject } from "rxjs";
import { Rekbot } from "../../../models/rekbot.model";
import { RekbotSettings } from "../../../models/rekbot-settings.model";
import { RekbotSettingsOpenHours } from "../../../models/rekbot-settings-open-hours.model";

interface RekbotState {
  rekbot: Rekbot;
  settings: RekbotSettings;
  openHours: RekbotSettingsOpenHours[]
}

export class RekbotStateService {
    private readonly emptyRekbot = Rekbot.empty();
    private readonly emptySettings = RekbotSettings.empty();
    private readonly emptyOpenHour = RekbotSettingsOpenHours.empty();

    private readonly stateSubject = new BehaviorSubject<RekbotState>({
        rekbot: this.emptyRekbot,
        settings: this.emptySettings,
        openHours: this.emptyOpenHour,
    });

    readonly state$ = this.stateSubject.asObservable();

    get rekbot(): Rekbot {
        return this.stateSubject.value.rekbot;
    }

    get settings(): RekbotSettings {
        return this.stateSubject.value.settings;
    }

    get openHours(): RekbotSettingsOpenHours[] {
        return this.stateSubject.value.openHours;
    }

    setRekbot(rekbot: Rekbot) {
        this.stateSubject.next({
            ...this.stateSubject.value,
            rekbot
        });
    }

    setSettings(settings: RekbotSettings) {
        this.stateSubject.next({
            ...this.stateSubject.value,
            settings
        });
    }

    setOpenHours(openHours: RekbotSettingsOpenHours[]) {
        this.stateSubject.next({
            ...this.stateSubject.value,
            openHours
        })
    }

    clear() {
        this.stateSubject.next({
            rekbot: this.emptyRekbot,
            settings: this.emptySettings,
            openHours: this.emptyOpenHour,
        });
    }

}